import { useContext } from 'react';
import { UpgradeContext } from './UpgradeContext';
import type { UpgradeContextType } from './types';

export const useUpgradeContext = () => {
  const context = useContext<UpgradeContextType>(UpgradeContext);
  if (!context) {
    throw new Error('useUpgradeContext must be used within a UpgradeProvider');
  }
  return context;
};
